export interface CookieConsent {
  analytics: boolean;
  marketing: boolean;
  timestamp: number;
  version: string;
}

export const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsent';
export const COOKIE_CONSENT_VERSION = '2025-07-17';

export function readStoredCookieConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as CookieConsent;
    if (parsed?.version === COOKIE_CONSENT_VERSION) {
      return parsed;
    }
  } catch {
    // ignore malformed storage
  }

  return null;
}

export function isAnalyticsCookiesAllowed(): boolean {
  return readStoredCookieConsent()?.analytics === true;
}
